import type { IconDefinition } from '../index.tsx';

export const iconAlert: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAlert',
  icon: [
    16,
    16,
    [],
    '',
    'M9.42123 0.376689C8.54181 -0.125563 7.45832 -0.125563 6.5789 0.376689L2.03664 2.97085C1.15722 3.4731 0.615479 4.4013 0.615479 5.40581V10.5941C0.615479 11.5986 1.15722 12.5268 2.03664 13.0291L6.5789 15.6233C7.45832 16.1255 8.54181 16.1255 9.42123 15.6233L13.9635 13.0291C14.8429 12.5268 15.3847 11.5986 15.3847 10.5941V5.40581C15.3847 4.4013 14.8429 3.4731 13.9635 2.97085L9.42123 0.376689ZM8.92323 3.69224H7.07709V8.30761H8.92323V3.69224ZM8.92323 10.1538H7.07709V11.9999H8.92323V10.1538Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
